import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdminContext } from "../context/AdminContext";

function FormUserConnection() {
  const { setIsAdmin } = useContext(AdminContext);

  const [nameAdmin, setNameAdmin] = useState("");
  const [passwordAdmin, setPasswordAdmin] = useState("");

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      nameAdmin === process.env.REACT_APP_ADMIN_USER_NAME &&
      passwordAdmin === process.env.REACT_APP_ADMIN_USER_MDP 
    ) {
      alert("C'est bon c'est toi l'admin !");
      setIsAdmin(true);
      setNameAdmin("");
      setPasswordAdmin("");      
      navigate("/add-photos");
      return;
    }
    alert("Alert qui est tu !");
    navigate("/bio");
  };

  return (
    <>
      <div className="titleAdmin">
        <h1>Connexion Admin</h1>
        <p>Se connecter pour accéder au formulaire d'ajout de Photos</p>
      </div>
      <form onSubmit={handleSubmit} className="formAdmin">
        <div className="nameAdmin">
          <label htmlFor="name">Nom</label>
          <input
            type="text"
            name="name"
            id="name"
            placeholder="nom"
            required
            onChange={(e) => setNameAdmin(e.target.value)}
          />
        </div>
        <div className="passwordAdmin">
          <label htmlFor="password">Mot de passe</label>
          <input
            type="password"
            name="password"
            id="password"
            required
            onChange={(e) => setPasswordAdmin(e.target.value)}
          />
        </div>
        <button type="submit">Connexion</button>
      </form>
    </>
  );
}

export default FormUserConnection;
